import {Link, Page} from './index';

export enum OverrideDataKey {
  ASSET_QUERY = 'assetQuery',
  BENCHMARK_VERSION = 'benchmarkVersion',
  RULE_NATURAL_ID = 'ruleNaturalId',
  RULE_TITLE = 'ruleTitle',
  POLICY_DISPLAY_NAME = 'policyDisplayName',
  RESULT_STATUS = 'resultStatus',
  CREATED_BY_USERNAME = 'createdByUsername',
  CREATED_TIME = 'createdTime',
  STATE = 'state',
  SCOPE = 'scope',
  POLICY_TITLE = 'policyTitle',
  EXPIRATION_TIME = 'expirationTime',
  COMMENT = 'comment',
  REVIEWER_REASON = 'reviewerReason',
}

export enum Expiration {
  DATE = 'date',
  NEVER = 'never',
}

export enum OverrideType {
  FAIL = 'NOT_VULNERABLE',
  FIXED = 'EXCEPTION_VULN_EXPL',
  NOT_APPLICABLE = 'SKIPPED_VERS',
  PASS = 'VULNERABLE_EXPL',
}

export enum OverrideScope {
  GLOBAL = 'global',
  SINGLE = 'single',
  IP_RANGE_HOSTNAME_NETMASK = 'ipRange_Hostname_Netmask',
  CUSTOM = 'custom',
}

export enum OverrideState {
  APPROVED = 'APPROVED',
  DELETED = 'DELETED',
  REJECTED = 'REJECTED',
  UNDER_REVIEW = 'UNDER_REVIEW',
}

export type Override = {
  assetKey: any;
  assetQuery: string | null;
  benchmarkNaturalId: string;
  benchmarkVersion: string;
  comment: any;
  createdByUsername: string;
  createdTime: string;
  expirationTime: any;
  id: number;
  isPolicyGlobal: boolean;
  profileNaturalId: string;
  resultStatus: string;
  reviewedByUsername: any;
  reviewedTime: any;
  reviewerReason: any;
  ruleNaturalId: string;
  state: string;
};

export type OverridesResponse = {
  links: Link[];
  page: Page;
  resources: Override[];
};

export type ExtendedOverride = Override & {
  [OverrideDataKey.RULE_TITLE]: string;
  [OverrideDataKey.SCOPE]: OverrideScope.SINGLE | OverrideScope.GLOBAL;
  [OverrideDataKey.POLICY_DISPLAY_NAME]?: string;
};

export type CreateOverrideInput = {
  assetKey: string | null;
  benchmarkNaturalId: string | undefined;
  benchmarkTitle: string | undefined;
  benchmarkVersion: string | undefined;
  comment: string;
  expirationTime: string | null;
  isPolicyGlobal: boolean;
  profileNaturalId: string | undefined;
  profileTitle: string | undefined;
  policyDisplayName: string | undefined;
  policyInternalId: string | undefined;
  assetQuery: string | null;
  resultStatus: OverrideType | null;
  ruleNaturalId?: string;
  ruleTitle: string | undefined;
  state: OverrideState;
};
